var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 319 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15C0 6.71573 6.71573 0 15 0H181C189.284 0 196 6.71573 196 15C196 23.2843 189.284 30 181 30H163.5C155.312 30 148.675 36.2678 148.675 44C148.675 51.7322 155.312 58 163.5 58H304C312.284 58 319 64.7157 319 73C319 81.2843 312.284 88 304 88H217.5C209.312 88 202.675 94.2678 202.675 102C202.675 109.732 209.312 116 217.5 116H234C242.284 116 249 122.716 249 131C249 139.284 242.284 146 234 146H49C40.7157 146 34 139.284 34 131C34 122.716 40.7157 116 49 116H163C171.188 116 177.825 109.732 177.825 102C177.825 94.2678 171.188 88 163 88H94C85.7157 88 79 81.2843 79 73C79 64.7157 85.7157 58 94 58H109C117.188 58 123.825 51.7322 123.825 44C123.825 36.2678 117.188 30 109 30H15C6.71573 30 0 23.2843 0 15Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud1);
export default __webpack_public_path__ + "static/media/cloud_1.3ee63876d690d45d1c26fdc42c8fa358.svg";
export { ForwardRef as ReactComponent };